import { t } from "i18next";
import React from "react";

import { NavigationSubMenuItem } from "./navigation-sub-menu-item/NavigationSubMenuItem";
import { useIsChildRouteEnabled } from "components/navigation/hooks/useIsChildRouteEnabled";
import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { NavigationLabel } from "components/navigation/navigation-panel/sub-navigation-panel/ui-components/navigation-label/NavigationLabel";
import { NavigationSubSection } from "components/navigation/navigation-panel/sub-navigation-panel/ui-components/navigation-sub-section/NavigationSubSection";
import { API_KEYS_ROUTE, RouteDefinition } from "components/router/Routes";

interface Props {
    mainRoute: RouteDefinition;
}

export const ConnectionsSubmenu = (props: Props) => {
    const isRouteEnabled = useIsRouteEnabled();
    const { isChildRouteEnabled, isChildRouteAdvertised } = useIsChildRouteEnabled();

    if (!props.mainRoute || !isRouteEnabled(props.mainRoute)) {
        return null;
    }

    return props.mainRoute.childRoutes.map((childroute) => {
        if (!isChildRouteEnabled(childroute)) {
            return null;
        }

        if (childroute === API_KEYS_ROUTE) {
            return (
                <React.Fragment key={childroute.path}>
                    <NavigationLabel>{t(API_KEYS_ROUTE.title)}</NavigationLabel>

                    <NavigationSubSection>
                        {API_KEYS_ROUTE.childRoutes.map((route) => {
                            if (!isChildRouteEnabled(route)) {
                                return null;
                            }

                            return (
                                <NavigationSubMenuItem
                                    key={route.path}
                                    to={route.path}
                                    isAdvertised={isChildRouteAdvertised(route)}
                                    testId={route.testId}
                                >
                                    {t(route.title)}
                                </NavigationSubMenuItem>
                            );
                        })}
                    </NavigationSubSection>
                </React.Fragment>
            );
        }

        return (
            <NavigationSubMenuItem
                key={childroute.path}
                to={childroute.path}
                isAdvertised={isChildRouteAdvertised(childroute)}
                testId={childroute.testId}
            >
                {t(childroute.title)}
            </NavigationSubMenuItem>
        );
    });
};
